/**
 * Productgalerij: pijlknoppen + thumbnails sturen de scroll-snap-track,
 * en bij swipen lopen de actieve thumbnail en pijl-status mee. Zonder JS
 * blijft de track gewoon swipe-/scrollbaar.
 */
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.querySelectorAll('[data-pdp-galerij]').forEach((galerij) => {
  const track = galerij.querySelector('[data-pdp-track]');
  const beelden = [...galerij.querySelectorAll('[data-pdp-beeld]')];
  const thumbs = [...galerij.querySelectorAll('[data-pdp-thumb]')];
  const vorige = galerij.querySelector('[data-pdp-vorige]');
  const volgende = galerij.querySelector('[data-pdp-volgende]');
  const blob = galerij.querySelector('.pdp__blob');
  if (!track || beelden.length < 2) return;

  let actief = 0;

  const zetActief = (index) => {
    actief = Math.max(0, Math.min(index, beelden.length - 1));
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-actief', i === actief);
      if (i === actief) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
    if (vorige) vorige.disabled = actief === 0;
    if (volgende) volgende.disabled = actief === beelden.length - 1;
    // Kleur-blob hoort alleen bij de hero-foto's (wens Mike): de eerste foto
    // en de hoofdfoto van elke variant, niet bij detailfoto's
    blob?.classList.toggle('is-onzichtbaar', !beelden[actief]?.hasAttribute('data-pdp-hoofd'));
  };

  const scrollNaar = (index) => {
    zetActief(index);
    // Beelden zijn exact één trackbreedte; index x breedte is dus de positie
    track.scrollTo({
      left: actief * track.clientWidth,
      behavior: reducedMotion.matches ? 'auto' : 'smooth',
    });
  };

  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => scrollNaar(i)));
  vorige?.addEventListener('click', () => scrollNaar(actief - 1));
  volgende?.addEventListener('click', () => scrollNaar(actief + 1));

  let raf = 0;
  track.addEventListener(
    'scroll',
    () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        zetActief(Math.round(track.scrollLeft / track.clientWidth));
      });
    },
    { passive: true }
  );

  // Start op de foto van de gekozen variant (?variant=... uit Google Shopping).
  // Het inline-script in de sectie scrollt al vóór de eerste weergave; dit is het vangnet.
  const start = Math.max(0, beelden.findIndex((b) => b.hasAttribute('data-pdp-start')));
  if (start > 0 && Math.round(track.scrollLeft / track.clientWidth) !== start) {
    track.scrollTo({ left: start * track.clientWidth, behavior: 'auto' });
  }
  zetActief(start);
  // en de thumbnail-strook (alleen die, niet de pagina) zodat de actieve thumb in beeld is
  const lijst = thumbs[start]?.parentElement;
  if (start > 0 && lijst) {
    const t = thumbs[start].getBoundingClientRect();
    const l = lijst.getBoundingClientRect();
    lijst.scrollBy({ top: t.top - l.top - 8, left: t.left - l.left - 8, behavior: 'auto' });
  }
});
